import React from 'react';
import {
  makeStyles,
  Typography,
  Grid
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root:{
      backgroundColor : theme.palette.background.default,
      textAlign:"center",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
  }
}));

const Footer: React.FC = () => {

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container direction="column" justifyContent="center">
        <Typography variant="subtitle2" color="textSecondary">© 2021 Finnize, Inc. All rights reserved</Typography>
      </Grid>
    </div>
  )
}

export default Footer;
